<markant-header dashboard-icon="true">
  <a slot="logoBar">
    <markant-header-logo-bar [logoUrl]="'assets/eservice_informationsmanagement_positiv.svg'"
                             [logoBarTitle]="name"></markant-header-logo-bar>
  </a>
</markant-header>
<markant-nav-drawer variant="docked" [open]="navOpen" (openChange)="handleNavOpenChange($event)">
  <markant-nav-item *ngFor="let token of tokens" [active]="token?.index === activeReport" slot="navItem"
                    icon="m_checkmark-outlined" (click)="changeReport(token.index)"
                    label="{{token?.name}}" extended></markant-nav-item>
    <main slot="app" class="content">
      <ng-container *ngFor="let token of tokens">
        <app-page *ngIf="isInRequestedReports(token.index)" id="{{token.index}}" class="report"
                  [hidden]="activeReport != token.index"
                  [token]="token"
                  [powerbi]="powerbi">
        </app-page>
      </ng-container>
    </main>
</markant-nav-drawer>
<markant-footer>
  <span slot="heading">Markant Services International GmbH</span>
  <a
    href="https://markant-net.markant.services/legal-notice"
    rel="noopener noreferrer"
    slot="content"
    target="_blank"
  >Impressum</a>
  <a
    href="https://markant-net.markant.services/data-privacy"
    rel="noopener noreferrer"
    slot="content"
    target="_blank"
  >Datenschutz</a>
</markant-footer>

